import {
  Box,
  CircularProgress,
  Typography
} from '@hiiretail/react-foundation-ui';
import { IntlShape } from "react-intl";

type EcoTaxLoadingPlaceholderProps = {
  isLoading: boolean;
  isError: boolean;
  intl: IntlShape;
}

const styles = {
  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    overflow: 'hidden',
    m: 3,
  },
};

export const EcoTaxLoadingPlaceholder = (
  { isLoading, isError, intl }: EcoTaxLoadingPlaceholderProps
) => (
  <Box sx={styles.box}>
    {isLoading && (
      <Box sx={styles.box}>
        <Typography>
          {intl.formatMessage({ id: 'receipt.loading.ecoTax' })}
        </Typography>
        <CircularProgress size={30} />
      </Box> 
    )}
    {isError && (
      <Typography>
        {intl.formatMessage({ id: 'receipt.ecoTax.unavailable' })}
      </Typography>
    )}
  </Box>
)
